import { cn } from '@/clientOnlyUtils/cn';
import type { ComponentProps } from 'react';

export default function TableCellHeader({
  children,
  className,
  ...props
}: ComponentProps<'div'> & { hover?: boolean }) {
  delete props.hover;

  return (
    <div
      className={cn(
        'peer flex items-center gap-3 px-6 py-3 text-sm transition-colors',
        'bg-slate-200 text-slate-700 dark:bg-slate-900 dark:text-slate-100',
        className,
      )}
      {...props}>
      {children}
    </div>
  );
}
